var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        entity: _vm.number,
        title: _vm.$t("PAUSE_NUMBER_MODAL_TITLE"),
        "cancel-button-text": _vm.$t("CANCEL"),
        "confirm-action-text": _vm.$t("PAUSE")
      },
      on: {
        confirm: _vm.confirmPause,
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("p", {
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("PAUSE_NUMBER_MODAL_TEXT", {
              phone: _vm.number.displayNumber
            })
          )
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }